(function () {
    'use strict';

    angular
        .module('ib-basket-module')
        .component('ibBasket', {
            controller: 'BasketController',
            controllerAs: 'basketCtrl',
            bindings: {
                model: '=',
                showButtonPay: '<',
                flightType:'='
            },
            templateUrl: ['$rootScope', function ($rootScope) {
                return $rootScope.routes.templates + 'ib-shopping-basket-view.html';
            }]
        });
})();
